import { ReactNode } from 'react';
import { Route as RouteDOM, RouteChildrenProps } from 'react-router-dom';

import { useLink } from './useLink';

type RouteParams<T> = { [K in keyof T]?: string };

function fixQuery<T>(
	params: RouteChildrenProps<RouteParams<T>>,
	path?: string[] | string,
	exact?: boolean,
): RouteChildrenProps<RouteParams<T>> {
	if (!path || Array.isArray(path)) {
		return params;
	}

	if (!path.includes('?') && !exact) {
		return params;
	}

	const search = path.indexOf('?') >= 0 ? path.substring(path.indexOf('?')) : '';

	if (params.location.search === search) {
		return params;
	}

	return { ...params, match: null };
}

export function Route<T>(props: {
	path?: string[] | string;
	exact?: boolean;
	children: ((props: RouteChildrenProps<RouteParams<T>>) => ReactNode) | ReactNode;
	exclusive?: boolean;
}) {
	const path = props.path
		? Array.isArray(props.path)
			? (props.path.map(useLink).filter(Boolean) as string[])
			: // eslint-disable-next-line react-hooks/rules-of-hooks
			  useLink(props.path)
		: undefined;

	return (
		<RouteDOM
			path={typeof path === 'string' ? path.replace(/\?.*$/, '') : path}
			exact={props.exact}
		>
			{props.exclusive
				? (params) =>
						params.match &&
						(typeof props.children === 'function' ? props.children(params) : props.children)
				: (params) =>
						typeof props.children === 'function'
							? props.children(fixQuery(params, path, props.exact))
							: props.children}
		</RouteDOM>
	);
}
